/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

// Plugins
import vuetify from "./vuetify";
import { createPinia } from "pinia";
import router from "@/router";
import { useUserStore } from "@/stores";
import phone from "./phone";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

import * as Sentry from "@sentry/vue";

import api, { setStore } from "./axios";

import VueApexCharts from "vue3-apexcharts";

export function registerPlugins(app) {
  const pinia = createPinia();
  pinia.use(piniaPluginPersistedstate);
  app.use(pinia);

  if (import.meta.env.VITE_SENTRY_ENABLED === "true") {
    Sentry.init({
      app,
      dsn: import.meta.env.VITE_SENTRY_URL,
      integrations: [
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
        Sentry.feedbackIntegration({
          colorScheme: "system",
        }),
      ],
      // Session Replay
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  }

  const userStore = useUserStore();
  setStore(userStore);

  app.use(vuetify).use(router).use(phone).use(VueApexCharts);

  app.config.globalProperties.$api = api;
}
